import { Service, signal } from '@angular/core';

/**
 * Whether the command palette is on screen.
 *
 * A service because two parties open it — the search button in the header and
 * the Ctrl+K listener in the palette itself — and neither owns the other.
 */
@Service()
export class CommandPaletteService {
  private readonly open = signal(false);

  readonly isOpen = this.open.asReadonly();

  show(): void {
    this.open.set(true);
  }

  hide(): void {
    this.open.set(false);
  }

  toggle(): void {
    this.open.update((open) => !open);
  }
}
